import React from 'react';

import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { EditMyDetails } from './edit_my_details';

/**
 * Returns Edit My Details Container with Snapshot Links
 * @param {Object} props - the incoming set of props
 * @return {Node} EditMyDetails returns EditMyDetails component
 */
const _EditMyDetailsContainer = (props) => <EditMyDetails {...props} />;

/**
 * Extract the following data from the store
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
export const mapStateToProps = (state) => {
    return {
        occupancyType: quoteFormSelector(state).getIn(['occupancy', 'occupancyType']),
        productCategory: quoteFormSelector(state).getIn(['coverDetails', 'coverType']),
        suburb: quoteFormSelector(state).getIn(['property', 'address', 'suburb']),
        hasMortgage: quoteFormSelector(state).getIn(['occupancy', 'hasMortgage']),
        howOccupied: quoteFormSelector(state).getIn(['occupancy', 'howOccupied']),
        movedInMonth: quoteFormSelector(state).getIn(['occupancy', 'whenMovedIn', 'month']),
        movedInYear: quoteFormSelector(state).getIn(['occupancy', 'whenMovedIn', 'year']),
        isPrincipalResidence: quoteFormSelector(state).getIn(['occupancy', 'isPrincipalResidence']),
        hasBusinessActivity: quoteFormSelector(state).getIn(['data', 'hasBusinessActivity']),
        managedBy: quoteFormSelector(state).getIn(['landlordDetails', 'managedBy']),
        hasValidRentalLease: quoteFormSelector(state).getIn(['landlordDetails', 'hasValidRentalLease']),
        weeklyRentalValue: quoteFormSelector(state).getIn(['landlordDetails', 'weeklyRentalValue']),
        propertyType: quoteFormSelector(state).getIn(['property', 'propertyType']),
        wallMaterial: quoteFormSelector(state).getIn(['property', 'wallMaterial']),
        roofMaterial: quoteFormSelector(state).getIn(['property', 'roofMaterial']),
        yearBuilt: quoteFormSelector(state).getIn(['property', 'yearBuilt']),
        hasBodyCorporate: quoteFormSelector(state).getIn(['property', 'hasBodyCorporate']),
        hasSecurityAlarm: quoteFormSelector(state).getIn(['data', 'hasSecurityAlarm']),
        totalRebuildCost: quoteFormSelector(state).getIn(['coverDetails', 'totalRebuildCost']),
        totalContentReplacementCost: quoteFormSelector(state).getIn(['coverDetails', 'totalContentReplacementCost']),
        totalUnspecifiedPortableItems: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'totalUnspecifiedPortableItems']),
        hasPortableItems: quoteFormSelector(state).getIn(['data', 'hasPortableItems']),
        bicyclesCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'bicyclesCover']),
        jewelryWatchesCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'jewelryWatchesCover']),
        clothingCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'clothingCover']),
        sportingEquipmentCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'sportingEquipmentCover']),
        musicalInstrumentsCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'musicalInstrumentsCover']),
        photographicEquipmentCover: quoteFormSelector(state).getIn(['coverDetails', 'portableItems', 'photographicEquipmentCover']),
        previousInsurer: quoteFormSelector(state).getIn(['previousCover', 'previousInsurer']),
        hasPreviousClaims: quoteFormSelector(state).getIn(['previousCover', 'hasPreviousClaims']),
        policyHolderFirstName: quoteFormSelector(state).getIn(['policyHolder', 'firstName']),
        policyHolderLastName: quoteFormSelector(state).getIn(['policyHolder', 'lastName']),
        policyHolderDob: quoteFormSelector(state).getIn(['policyHolder', 'dob']),
        commencementDate: quoteFormSelector(state).getIn(['coverDetails', 'commencementDate'])
    };
};

const EditMyDetailsContainer = connect(mapStateToProps)(_EditMyDetailsContainer);

export { _EditMyDetailsContainer, EditMyDetailsContainer };
